/**
 * Runtime configuration — what the portal needs before it can render.
 *
 * In production the stack writes `/config.json` next to `index.html` at
 * deploy time (the Cognito ids do not exist until the pool does), and the
 * same build artefact therefore works for any stage. In dev it comes from
 * Vite env vars, so a developer points at the local backend, Floci, or a
 * real stack with `.env.local` alone.
 */
export interface RuntimeConfig {
  apiUrl: string;
  cognito: { userPoolId: string; userPoolClientId: string };
}

let cfg: RuntimeConfig | null = null;

export function getRuntimeConfig(): RuntimeConfig {
  if (!cfg)
    throw new Error(
      "runtime config not loaded — call loadRuntimeConfig() first",
    );
  return cfg;
}

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (cfg) return cfg;
  if (import.meta.env.DEV) {
    cfg = {
      apiUrl: import.meta.env.VITE_API_URL ?? "http://localhost:4000",
      cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "",
        userPoolClientId:
          import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? "",
      },
    };
    return cfg;
  }
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`config.json answered ${res.status}`);
  cfg = (await res.json()) as RuntimeConfig;
  return cfg;
}
